import React, { useEffect, useState } from 'react';
import api from '../api';

const H2 = 'h2';

const reais = (valor) => valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

function Regras() {
  // Mensalidade e diária vêm das Configurações (VALOR_MENSALIDADE / VALOR_DIARIA)
  const [valores, setValores] = useState({});
  useEffect(() => {
    api
      .get('regras/valores')
      .then(({ data }) => setValores(data || {}))
      .catch(() => setValores({}));
  }, []);
  const valor = (n) => (Number.isFinite(n) ? <b>{reais(n)}</b> : 'o valor definido pela diretoria');

  return (
    <div>

      <H2>1 - Tempo de Partida</H2>
      <p>
        1.1 As partidas têm duração prevista de 10 minutos. A primeira partida
        terá duração de 15 minutos quando houver apenas 8 atletas (de linha) no
        período de concentração até o apito inicial da primeira partida.
      </p>
      <p>
        1.2 O tempo da partida é corrido e SOMENTE será suspenso em razão de
        atendimento ao atleta em campo.
      </p>

      <H2>2 - Check-in e Formação das Equipes</H2>
      <p>
        2.1 <b>Check-in.</b> O check-in ("Chegou" no app) é liberado a partir das <b>19h</b> (horário de
        Brasília) do dia da pelada, para quem confirmou presença. O atleta só pode marcar a chegada quando estiver
        no local da concentração com o material de jogo — o app confere a localização ou o check-in é feito
        encostando o celular na tag NFC da concentração. Atletas envolvidos em atividades esportivas anteriores
        não podem marcar chegada até estarem presentes na concentração.
      </p>
      <p>
        PARÁGRAFO ÚNICO: Quem for embora sai da fila de espera, mas o check-in continua valendo (estatísticas,
        avaliação e mensalidade). Se voltar, retorna à mesma posição.
      </p>

      <p>2.2 <b>Ordem de chegada.</b> A fila segue estas prioridades, nesta ordem:</p>
      <ul>
        <li>
          <b>Chegada tardia:</b> quem fizer o check-in a partir das <b>20h</b> (horário de Brasília) perde qualquer
          prioridade e vai para o fim da fila, por ordem de chegada — vale para mensalista, diarista e convidado.
        </li>
        <li><b>Tipo de jogador:</b> mensalistas têm prioridade sobre diaristas e convidados.</li>
        <li>
          <b>Adimplência:</b> entre mensalistas, quem está em dia vem antes de quem tem débito em aberto
          (mensalidades, inclusive a do mês corrente assim que é gerada, e diárias). A diária de convidado da pelada
          do dia não conta como débito. Entre diaristas, essa regra não se aplica.
        </li>
        <li><b>Ordem de chegada:</b> nas demais situações, quem chegou primeiro tem prioridade.</li>
      </ul>
      <p>
        PARÁGRAFO ÚNICO: A fila pode ser reorganizada no app, mas só a diretoria pode colocar um atleta sem
        prioridade (diarista, convidado, com débito ou com chegada tardia) à frente de um mensalista em dia.
      </p>

      <p>
        2.3 <b>Primeira partida.</b> Com pelo menos <b>8 atletas</b> na fila, os 8 primeiros formam os dois
        primeiros times; os demais aguardam na fila de espera. Os times podem ser formados pela diretoria, pelo
        árbitro ou por qualquer atleta que já fez check-in.
      </p>
      <p>
        PARÁGRAFO PRIMEIRO: Os 8 atletas são divididos de forma equilibrada pelo ranking. Cada atleta recebe uma
        nota de 0 a 100, nesta ordem de preferência:
      </p>
      <ul>
        <li>a média das estrelas recebidas nas avaliações da pelada no ano (com pelo menos 5 notas);</li>
        <li>
          se não tiver, a posição no ranking da votação dos potes do torneio mais recente que já teve jogos e mais
          de 12 inscritos;
        </li>
        <li>se não tiver nenhuma das duas, o pote (1 a 6) informado na hora de formar os times.</li>
      </ul>
      <p>
        PARÁGRAFO SEGUNDO: Entre todas as divisões possíveis, vale a de menor diferença entre as notas dos dois
        times. A nota de cada atleta e a média de cada time aparecem na tela de partidas.
      </p>

      <p>
        2.4 <b>Partidas seguintes.</b> O time vencedor permanece em campo e o perdedor vai para o fim da fila, na
        ordem de chegada. Entram os 4 primeiros da fila. A ordem de chegada prevalece sempre para a composição da
        equipe da partida seguinte, portanto não existe decisão por pênaltis caso alguém esteja na fila de espera.
      </p>

      <p>
        2.5 <b>Completar o time.</b> Se o time que vai entrar não tiver 4 atletas, ele é completado por atletas que
        acabaram de sair de campo (que perderam ou saíram no empate):
      </p>
      <ul>
        <li>tem a vez quem <b>completou menos vezes</b> naquela pelada;</li>
        <li>com o mesmo número de vezes, quem chegou primeiro.</li>
      </ul>
      <p>
        PARÁGRAFO ÚNICO: Completar um time conta como usar a vez — na próxima necessidade, completa quem ainda
        não completou. O app mostra no cartão de cada atleta quantas vezes ele já completou.
      </p>

      <p>
        2.6 <b>Atrasados.</b> Quem faz o check-in com partidas em andamento entra na fila automaticamente: se ainda
        há atletas que não jogaram, logo depois deles; se todos já jogaram, logo após o próximo time — ou seja,{' '}
        <b>não joga a próxima partida</b>.
      </p>

      <p>2.7 <b>Empate.</b></p>
      <ul>
        <li>
          Com até <b>4 atletas</b> esperando: sai o time que já estava em campo na partida anterior e fica o que
          acabou de entrar (a vantagem do empate é de quem entrou). A fila entra no lugar, completada conforme o
          item 2.5.
        </li>
        <li>
          Com <b>mais de 4</b> esperando (ou quando os dois times entraram juntos): saem os dois times e entram os
          próximos da fila, completados conforme o item 2.5.
        </li>
      </ul>

      <p>
        2.8 <b>Segunda vitória consecutiva.</b> Se houver <b>5 ou mais</b> atletas esperando, saem os dois times:
        jogam os próximos da fila e o time das duas vitórias volta na partida seguinte, à frente da fila. Com até 4
        esperando, o time que venceu continua em campo.
      </p>

      <p>
        2.9 A partida será disputada por duas equipes, cada uma composta por cinco
        atletas, onde um dos quais, obrigatoriamente, será o goleiro.
      </p>
      <p>
        2.10 Qualquer um dos atletas poderá trocar de posição com o goleiro, desde
        que tal alteração seja efetuada quando de uma paralisação da partida.
      </p>

      <H2>3 - Início da Partida</H2>
      <p>
        3.1- Para o início da partida a escolha do goleiro ou pontapé inicial será
        sorteado utilizando-se o jogo do par ou ímpar; o lado favorecido escolherá
        a saída de bola ou o goleiro.
      </p>

      <H2>4 - Substituição</H2>
      <p>
        4.1 O próximo da vez será o substituto na partida vigente, podendo jogar a
        próxima partida em sua totalidade somente em casos de contusão do atleta que
        será substituído. Em qualquer outro caso o próximo atleta pode ser alguém
        da fila de espera, que automaticamente perde a vez.
      </p>

      <H2>5 – Infrações e penalidades</H2>
      <p>
        5.1 Quando houver árbitro na partida o mesmo tem total autoridade,
        prevalecendo sua decisão em qualquer caso, estando limitado às decisões de
        campo.
      </p>
      <p>
        5.2 Quando não houver árbitro na partida a infração só pode ser marcada
        pelo atleta que está envolvido diretamente na jogada (disputando a bola) se
        outro atleta paralisar a partida receberá um cartão amarelo mesmo que não
        haja árbitro.
      </p>
      <p>
        5.3 Em caso de retorno da bola ao goleiro o mesmo só poderá pegar a bola
        com a mão se o retorno for realizado de cabeça ou peito. Em lateral ou escanteio, o goleiro só
        pode pegar com a mão quando a cobrança for feita <b>com as mãos</b>; se for cobrada com o pé, não pode.
        Caso não seja realizado de nenhuma das formas permitidas deve ser
        marcada a infração e o time favorecido deverá escolher onde será cobrada a
        falta fora da área do goleiro.
      </p>
      <p>
        5.4 É proibida a utilização de carrinho para disputa de bola, visto o
        tamanho do nosso campo, o que pode causar contusões com alta gravidade,
        caso ocorra o atleta receberá um cartão amarelo automaticamente mesmo que
        não haja árbitro na partida.
      </p>
      <p>
        5.5 Em caso de aplicação de 2 cartões amarelos na partida ao mesmo atleta,
        o mesmo receberá um cartão azul e passará 2 minutos fora da partida ou até
        que seu time sofra um gol.
      </p>
      <p>
        5.6 Em caso do atleta atacante sofrer uma falta como por exemplo ( puxada de
        camisa, abraço, puxão no braço, carrinho por trás, faltas maliciosas) e
        possua apenas um atleta de defesa impossibilitando a marcação de um gol, o
        infrator receberá o cartão azul automaticamente.
      </p>
      <p>
        5.7 Caso o goleiro pegue com a mão a bola fora da área, o mesmo deve receber
        um cartão amarelo e a infração deve ser marcada no local onde a bola foi
        tocada com a mão. Obs: A referência é a bola e não o corpo do goleiro sendo
        assim, se a bola estiver fora da área e o corpo do goleiro dentro a infração
        deve ser marcada.
      </p>
      <p>
        5.8 Em caso do atleta cometer uma penalidade de modo a desvirtuar o principal
        objetivo da diversão ou ofender algum colega da pelada, o mesmo deve receber
        cartão vermelho e estará suspenso da partida em andamento, podendo retornar
        no mesmo dia.
      </p>
      <p>
        5.9 No caso da aplicação do cartão azul, o atleta poderá voltar
        imediatamente, caso qualquer um dos times marque um gol;
      </p>
      <p>
        5.10 A marcação branca para cobrança do pênalti deve ser utilizada apenas
        como referência, o local exato para cobrança será de dois passos a mais de
        distância em sentido oposto ao da posição do goleiro defensor.
      </p>

      <H2>6 – Taxa de manutenção</H2>
      <p>
        6.1 A mensalidade de {valor(valores.valorMensalidade)} por mês deve ser paga pelos atletas para que seja
        realizada a manutenção do material utilizado na pelada e pagamento de
        contratação dos goleiros e árbitros. Em dezembro o valor que restar no caixa
        será usado na confraternização da pelada com a devida prestação de contas.
        Em caso de 2 meses ou mais atraso no pagamento o atleta poderá ser convidado
        a se retirar da pelada e não poderá participar da festa de confraternização.
      </p>
      <p>
        6.2 Só poderá participar das deliberações no grupo da pelada e emitir sua
        opinião, aquele que se encontrar quite com sua colaboração mensal;
      </p>

      <H2>7 Vestimenta e material dos atletas.</H2>
      <p>
        7.1 É obrigatório o atleta entrar em campo com o padrão oficial da pelada.
        O convidado poderá utilizar colete amarelo ou colete azul, podendo usar
        também uma camisa de mesma cor (o atleta deve possuir 2 camisas para
        eventual troca).
      </p>

      <H2>8 – Convidados</H2>
      <p>
        8.1 Fica proibida a participação de convidados caso exista 3 times completos
        ou mais.
      </p>
      <p>
        8.2 A diária de {valor(valores.valorDiaria)} por pelada é cobrada do morador que trouxer um
        convidado (lançada no check-in do convidado) e deve ser paga antes de iniciar a partida. O diarista
        paga a mesma diária a cada pelada.
      </p>

      <H2>9 – Avaliação da pelada</H2>
      <p>
        9.1 Após o fim da pelada, a avaliação abre no app por 24 horas. Avaliam os atletas que fizeram check-in e
        os goleiros escalados, dando de 1 a 5 estrelas a cada atleta da pelada. É obrigatório avaliar todos da
        lista, e ninguém avalia a si mesmo.
      </p>
      <p>
        9.2 O <b>crack da pelada</b> é quem tiver a maior média entre os que receberam o número mínimo de notas
        (metade do maior número de notas recebidas por um atleta na pelada); em caso de empate, vale quem recebeu
        mais notas de 4 e 5 estrelas. A <b>bola murcha</b> é a menor média entre os que receberam o mínimo de notas.
      </p>
      <p>
        9.3 As médias do ano formam o ranking das avaliações no Painel e são usadas na formação da primeira
        partida (item 2.3).
      </p>
    </div>
  );
}

export default Regras;
